import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface ClassPerformanceLowEnrollment {
  classFilledCount: number;
  classId: string;
  className: string;
  classOccupency: number;
  classTotalCapacity: number;
}

export interface GetClassPerformanceLowEnrollmentParams {
  sessionId: string;
}

export const getClassPerformanceLowEnrollmentAPI = async (
  params: GetClassPerformanceLowEnrollmentParams,
) => {
  const response = await baseAPI.get<Array<ClassPerformanceLowEnrollment>>(
    '/dashboard/class-performance/low-enrollment',
    { params },
  );
  return response.data;
};

export const useGetClassPerformanceLowEnrollment = (
  params: GetClassPerformanceLowEnrollmentParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.CLASS_PERFORMANCE_LOW_ENROLLMENT, params.sessionId],
    queryFn: () => getClassPerformanceLowEnrollmentAPI(params),
    enabled: !!params.sessionId,
  });
};
